import type { IngredientId } from '@libs/trip-planner-interfaces';

export const enum TripOverviewPanelType {
  None = 'none',
  HotelDetails = 'hotelDetails',
  ActivityDetails = 'activityDetails',
  Configuration = 'configuration',
  ConfigurationStepper = 'configurationStepper',
  FerryFilters = 'ferryFilters',
  TripPriceSummary = 'tripPriceSummary',
  HotelFilters = 'hotelFilters',
  FlightsFilters = 'flightsFilters',
}

export interface TripOverviewHotelDetailsPanel {
  type: TripOverviewPanelType.HotelDetails;
  hotelCode: string;
  ingredientId: IngredientId;
}

export interface TripOverviewActivityDetailsPanel {
  type: TripOverviewPanelType.ActivityDetails;
  hotelCode: string;
  ingredientId: IngredientId;
}

export interface TripOverviewNoPanel {
  type: TripOverviewPanelType.None;
}

export interface TripOverviewConfigurationPanel {
  type: TripOverviewPanelType.Configuration;
}

export interface TripOverviewConfigurationStepperPanel {
  type: TripOverviewPanelType.ConfigurationStepper;
}

export interface TripOverviewFerryFiltersPanel {
  type: TripOverviewPanelType.FerryFilters;
}

export interface TripOverviewTripPriceSummaryPanel {
  type: TripOverviewPanelType.TripPriceSummary;
}

export interface TripOverviewHotelFiltersPanel {
  type: TripOverviewPanelType.HotelFilters;
}

export interface TripOverviewFlightsFiltersPanel {
  type: TripOverviewPanelType.FlightsFilters;
}

export type TripOverviewPanel =
  | TripOverviewHotelDetailsPanel
  | TripOverviewActivityDetailsPanel
  | TripOverviewNoPanel
  | TripOverviewConfigurationPanel
  | TripOverviewConfigurationStepperPanel
  | TripOverviewFerryFiltersPanel
  | TripOverviewTripPriceSummaryPanel
  | TripOverviewFlightsFiltersPanel
  | TripOverviewHotelFiltersPanel;

export const TRIP_OVERVIEW_NO_PANEL: TripOverviewNoPanel = {
  type: TripOverviewPanelType.None,
};

export const TRIP_OVERVIEW_CONFIGURATION_PANEL: TripOverviewConfigurationPanel =
  {
    type: TripOverviewPanelType.Configuration,
  };

export const TRIP_OVERVIEW_CONFIGURATION_STEPPER_PANEL: TripOverviewConfigurationStepperPanel =
  {
    type: TripOverviewPanelType.ConfigurationStepper,
  };

export const TRIP_OVERVIEW_FERRY_FILTERS_PANEL: TripOverviewFerryFiltersPanel =
  {
    type: TripOverviewPanelType.FerryFilters,
  };
export const TRIP_OVERVIEW_NEW_TRIP_PRICE_SUMMARY_PANEL: TripOverviewTripPriceSummaryPanel =
  {
    type: TripOverviewPanelType.TripPriceSummary,
  };

export const TRIP_OVERVIEW_HOTEL_FILTERS_PANEL: TripOverviewHotelFiltersPanel =
  {
    type: TripOverviewPanelType.HotelFilters,
  };

export const TRIP_OVERVIEW_FLIGHTS_FILTERS_PANEL: TripOverviewFlightsFiltersPanel =
  {
    type: TripOverviewPanelType.FlightsFilters,
  };
